import React from "react";

export const Button = ({children, className, ...props}) =>   (
    <button
        {...props}
        className={`${className} form__button`}
        >{children}</button>
);
